import { render } from "./Organisationsbeschreibung.pug?vue&type=template&id=a0f45f46&lang=pug"
import script from "./Organisationsbeschreibung.js?vue&type=script&lang=js"
export * from "./Organisationsbeschreibung.js?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__